import { Resort } from '@entities/resort/@/hotel';
import { Country } from '@entities/country/@/hotel';

export enum RenovationType {
    RecentlyOpened = 'recently_opened',
    FreshRenovation = 'fresh_renovation',
}

export interface Hotel {
    id: number;
    resort: Resort | null;
    country: Country | null;
    attributes: number[]
    beachLine: number | null;
    hotelCategory: number;
    name: string;
    ordersNumber: number;
    placement: null;
    rating: number;
    reviewsNumber: number;
    renovationDate: null | number;
    builtDate: null | number;
    renovationTypes: RenovationType[];
    types: number[]
    childServices?: number[];
    restTypes?: number[];
    beachType?: number;
}
